import Login from '@assets/login/login';
import listener from '../../utils/listener';

export default class extends Login {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }

  init() {
    super.init();
    this.tabs();
    this.appleOuthLogin();
    this.fidelityCardTooltip();
    this.handlerAccordion();
    this.loginAnalytics();
  }

  loginAnalytics() {
    $('form.login').on('login:success', (e, data) => {
      if (data && data.customerNo) {
        listener.dataLayerLoginHandler(data.customerNo);
      }
    });
  }

  handlerAccordion() {
    $(document).on('click', '.fidelity-card-disclaimer-container .accordion-handler', (e) => {
      const $this = $(e.currentTarget);
      const $content = $this.next('.accordion-content');
      const isOpen = $this.hasClass('open');
      $this.toggleClass('open').attr('aria-expanded', !isOpen);
      $content.stop().slideToggle(300);
    });
  }

  fidelityCardTooltip() {
    const $tooltip = $('#fidelity-card-info-tooltip');
    const $wrapper = $('.fidelity-card-tooltip-wrapper');
    let hideTimeout;
    let isPinned = false;

    const positionTooltip = function () {
      const $trigger = $('#js-fidelity-card-info-tooltip');
      if ($trigger.length && $wrapper.length) {
        const triggerOffset = $trigger.offset();
        const wrapperOffset = $wrapper.offset();
        const triggerTopFromWrapper = triggerOffset.top - wrapperOffset.top;
        const gap = 8;
        $tooltip.css({ top: 'auto', bottom: $wrapper.outerHeight() - triggerTopFromWrapper + gap + 'px', left: 0, width: '100%' });
      }
    };

    const showTooltip = function () {
      clearTimeout(hideTimeout);
      positionTooltip();
      $tooltip.show().attr('aria-hidden', 'false');
    };

    const hideTooltip = function () {
      $tooltip.hide().attr('aria-hidden', 'true');
    };

    const scheduleHide = function () {
      if (isPinned) return;
      hideTimeout = setTimeout(hideTooltip, 100);
    };

    $(document)
      .on('mouseenter', '#js-fidelity-card-info-tooltip', showTooltip)
      .on('mouseleave', '#js-fidelity-card-info-tooltip', scheduleHide)
      .on('mouseenter', '#fidelity-card-info-tooltip', showTooltip)
      .on('mouseleave', '#fidelity-card-info-tooltip', scheduleHide)
      .on('click', '#js-fidelity-card-info-tooltip', function (e) {
        e.preventDefault();
        e.stopPropagation();
        isPinned = !isPinned;
        if (isPinned) {
          showTooltip();
        } else {
          hideTooltip();
        }
      })
      .on('click', '#fidelity-card-info-tooltip', function (e) {
        e.stopPropagation();
      })
      .on('click', function (e) {
        if (isPinned && !$(e.target).closest('#js-fidelity-card-info-tooltip, #fidelity-card-info-tooltip').length) {
          isPinned = false;
          hideTooltip();
        }
      });
  }

  tabs() {
    $('.nav-tabs').on('click', '.nav-link', (e) => {
      return $(e.currentTarget).attr('aria-controls') === 'register'
        ? $('.card-trackorder, .card-wishlist').removeClass('h-100').addClass('fit-content')
        : $('.card-trackorder, .card-wishlist').addClass('h-100').removeClass('fit-content');
    });
  }

  appleOuthLogin() {
    // Listen for authorization success.
    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
      // Handle successful response.
      const url = $('#appleid-signin').data('redirect');
      const dataToSend = Object.assign(event.detail.authorization, { ajax: true });
      $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: dataToSend,
        success: function (response) {
          window.location.href = response.redirectUrl;
        },
        error: function (err) {
          // Handle Ajax Error
          // eslint-disable-next-line
          console.log('Ajax error: ' + JSON.stringify(err));
        }
      });
    });

    document.addEventListener('AppleIDSignInOnFailure', (event) => {
      // Handle error.
      // eslint-disable-next-line no-console
      console.error(event.detail.error);
    });
  }
}
